import { SPECIES_MASTER } from "../../../../enums/QueryKeys";
import { useFetch } from "../../../../hooks/Fetching";

//Component used only by master and can't be accessed by anyone else
//It fetched ALL species from the database
export default function useSpecies() {
  const url = '/species/'
  const { data, isLoading, error } = useFetch(url, null, SPECIES_MASTER);
  return { data, isLoading, error };
}
